import { c as _c } from "react/compiler-runtime";
export default function UserCICTypeIconTooltipHeaders() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <><p className="tw-mb-0 tw-text-sm tw-text-white tw-font-semibold">Network ID Check</p><p className="tw-mb-0 tw-mt-1 tw-text-sm tw-text-iron-400 tw-font-normal">Does the community believe this profile accurately represents its identity?</p></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}